import { StreamSearchTagsQueryQuery } from '@shared/api/graphql/generated';

import { ActiveTagType } from './ActiveTagType';

export const getFlattenTags = (tags?: StreamSearchTagsQueryQuery['result']['tags']): ActiveTagType[] => {
  const activeTags: ActiveTagType[] = [];

  tags?.forEach((tag) => {
    activeTags.push({ id: tag.id, title: tag.title });

    tag.children.forEach((child) => {
      if (child !== null) {
        activeTags.push({ id: child.id, title: child.title });
      }
    });
  });

  return activeTags;
};
